import { baseUrl, getInitialRoute } from "../../../../utils"
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";

export const appsMorePreviewJson = (type) => {
    const initalRoute = getInitialRoute();
    const product = initalRoute == 'widget';
    const socialWalls = initalRoute == 'socialwalls';
    switch (type) {
        case "Custom Post":
            return {
                title: "Custom Post",
                description: `Inserts Custom Content of your choice in your ${product ? 'Widget' : 'wall'}.`,
                svg: <FontAwesomeIcon type={'duotone'} icon={'clone'} iconClass="fa-solid icon-gradient fs-2" />
            }

        case "Profanity Filter":
            return {
                title: "Profanity Filter",
                description: "Auto filters profane content based on pre-defined list of unwanted words.",
                svg: <FontAwesomeIcon type={'duotone'} icon={'ban'} iconClass="fa-solid icon-gradient fs-2" />
            }

        case "Analytics":
            return {
                title: "Analytics",
                description: "Activate analytics and view how your social platforms are performing.",
                svg: <FontAwesomeIcon type={'duotone'} icon={'chart-simple'} iconClass="fa-solid icon-gradient fs-2" />
            }

        case "Collaboration":
            return {
                title: "Collaboration",
                description: "Add your team members and give them rights to manage your social hubs.",
                svg: <FontAwesomeIcon type={'duotone'} icon={'thumbs-up'} iconClass="fa-solid icon-gradient fs-2" />
            }

        case "Download Images":
            return {
                title: "Download Images",
                description: `This feature allows you to Download all the images of your ${product ? 'Widget' : 'wall'}.`,
                svg: <FontAwesomeIcon type={'duotone'} icon={'download'} iconClass="fa-solid icon-gradient fs-2" />
            }

        case "SnapUp":
            return {
                title: "SnapUp",
                description: "Collect visual UGC and reviews from your audience to showcase them across different channels.",
                svg: <img src={baseUrl('icons/svg-icons/snapup-1.svg')} width={'30px'} height={'70px'} />
            }

        case "Custom CSS":
            return {
                title: "Custom CSS",
                description: `Add your Custom CSS to personalize the look of your ${product ? 'Widget' : 'wall'}.`,
                svg: <FontAwesomeIcon type={'duotone'} icon={'code'} iconClass="fa-solid icon-gradient fs-2" />
            }

        case "Ticker":
            return {
                title: "Ticker",
                description: `Allows you to run Ticker messages at the bottom of your social wall.`,

                svg: <img src={baseUrl('icons/svg-icons/ticker-1.svg')} width={'30px'} height={'70px'} />
            }

        case "Full Screen Announcements":
            return {
                title: "Full Screen Announcements",
                description: "Allows you to make full screen announcements to Audience.",
                svg: <FontAwesomeIcon type={'duotone'} icon={'bullhorn'} iconClass="fa-regular icon-gradient fs-2" />
            }
        case "Super Refresh":
            return {
                title: "Super Refresh",
                description: "Refreshes your social wall across all screens.",
                svg: <FontAwesomeIcon type={'duotone'} icon={'rocket-launch'} iconClass="fa-regular icon-gradient fs-2" />

            }

        case "Interaction":
            return {
                title: "Reactions",
                description: "Let users interact with your social wall in real-time.",
                svg: <FontAwesomeIcon type={'solid'} icon={'heart'} iconClass="fa-regular icon-gradient fs-2" />
            }


        default:
            return {};
    }

}